export const defaultForm = {
  noSleepers: null,
  mattressSize: null,
  sleeper: [
    {
      name: '',
      weight: '',
      height: '',
      waist: '',
      sleepPosition: '',
      sleepGoal: '',
    },
  ],
};
